<template>
  <div class="transctl">
    <div class="banner_wrapper">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item>{{$t('tradeMng.crumbs.L1')}}</el-breadcrumb-item>
        <el-breadcrumb-item>{{$t('tradeMng.crumbs.L4')}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="panel down">
      <div class="panel-header panel-header__auto">
        <el-form :model="form" :rules="formrules" ref="form">
          <div class="panel-select-group">
            <div class="panel-select__wrapper">
              <span class="panel-select__desc">{{$t('tradeMng.panel.time')}}</span>
              <el-form-item prop="dateRangeValue">
                <el-date-picker
                  v-model="form.dateRangeValue"
                  type="datetimerange"
                  :editable="false"
                  :placeholder="$t('tradeMng.panel.range')"
                  size="small"
                  :clearable="false">
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="choosetime">
                <el-select v-model="form.choosetime" :placeholder="$t('common.all')" size="small" @change="changeTime">
                  <el-option v-for="item in choosetimes" :label="item.name" :value="item.value" :key="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

          </div>
          <div class="panel-select-group">
            <div class="panel-select__wrapper" v-if="!role.single">
              <span class="panel-select__desc">{{$t('tradeMng.panel.shopName')}}</span>
              <el-form-item prop="selectShopUid">
                <el-select v-model="form.selectShopUid" filterable :placeholder="$t('tradeMng.panel.tip1')" size="small" @change="getOperators" :loading="shopLoading">
                  <el-option v-for="shop in shopData.list" :label="shop.shop_name" :value="shop.uid" :key="shop.uid">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="panel-select__wrapper" v-if="!role.isCashier">
              <span class="panel-select__desc">{{$t('tradeMng.panel.operator')}}</span>
              <el-form-item prop="operaValue">
                <el-select v-model="form.operaValue" :placeholder="$t('tradeMng.table.all')" size="small" :disabled="form.selectShopUid === ''">
                  <el-option :label="$t('tradeMng.table.all')" value=""></el-option>
                  <el-option :label="$t('tradeMng.table.main')" value="vl"></el-option>
                  <el-option v-for="(label, value) in operaList" :label="label" :value="value" :key="value"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <!-- 支付方式 -->
          <div class="panel-select-group" v-if="typeList.length > 0">
            <div class="panel-select__wrapper">
              <span class="panel-select__desc">{{$t('tradeMng.table.colWay')}}</span>
              <el-form-item prop="checkAll1">
                <el-checkbox v-model="form.checkAll1" @change="handleCheckAllChange1">{{$t('tradeMng.panel.noLimit')}}</el-checkbox>
              </el-form-item>
              <el-form-item prop="type">
                <el-checkbox-group v-model="form.type" @change="handleCheckedCitiesChange1">
                  <el-checkbox v-for="item in typeList" :label="item.value" :key="item.value">{{ item.name }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </div>
          <!-- 更多筛选 -->
          <!-- <div class="panel-select-group">
            <div class="panel-select__wrapper">
              <span class="panel-select__desc">{{$t('tradeMng.panel.moreFilter')}}</span>
              <el-form-item prop="checkAll2">
                <el-checkbox v-model="form.checkAll2" @change="handleCheckAllChange2">{{$t('tradeMng.panel.noLimit')}}</el-checkbox>
              </el-form-item>
              <el-form-item prop="other">
                <el-checkbox-group v-model="form.other" @change="handleCheckedCitiesChange2">
                  <el-checkbox v-for="item in otherList" :label="item.value" :key="item.value">{{ item.name }}</el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </div>
          </div> -->

          <div class="panel-select-group">
            <div class="panel-select__wrapper orderno_nowrap">
              <span class="panel-select__desc">{{$t('tradeMng.panel.sNum')}}</span>
              <el-form-item prop="orderno">
                <el-input v-model="form.orderno" type="number" :placeholder="$t('tradeMng.msg.m8')" size="small" class="panel-select-input__fix panel-select-input-220"></el-input>
              </el-form-item>
            </div>
            <div class="panel-select__wrapper">
              <span class="panel-select__desc">{{$t('tradeMng.panel.chnlsn')}}</span>
              <el-form-item prop="chnlsn">
                <el-input v-model="form.chnlsn" :placeholder="$t('tradeMng.msg.m17')" size="small" class="panel-select-input__fix panel-select-input-220"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="panel-select-group">
            <div class="panel-select__wrapper orderno_nowrap">
              <span class="panel-select__desc">{{$t('tradeMng.table.merchantOrder')}}</span>
              <el-form-item prop="outtradeno">
                <el-input v-model="form.outtradeno" :placeholder="$t('tradeMng.msg.m18')" size="small" class="panel-select-input__fix panel-select-input-220"></el-input>
              </el-form-item>
            </div>
            <!-- card scheme -->
            <div class="panel-select__wrapper orderno_nowrap" v-if="isAdvancedSearchClick">
              <span class="panel-select__desc">{{$t('tradeMng.panel.cardScheme')}}</span>
              <el-form-item prop="cardscheme">
                <el-select v-model="form.cardscheme" size="small" :placeholder="$t('common.all')">
                  <el-option v-for="scheme in schemeList" :label="scheme.name" :value="scheme.value" :key="scheme.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="panel-header-btn-group" :class="{'advanced_group': isScreenSmall, 'advanced_group_large_style': isAdvancedSearchClick && isScreenBig, 'advanced_group_resize': isScreenSmall && isAdvancedSearchClick}">
              <div class="panel-header-btn panel-header-btn__fill advance" @click="advancedSearch" v-if="isCardPayment">
                <p>{{$t('tradeMng.panel.btn.advancedSearch')}}</p>
                <i class="el-icon-arrow-down" :class="{'advanced_arrow': isAdvancedSearchClick}"></i>
              </div>
              <div class="panel-header-btn panel-header-btn__fill" :class="{'margin19': isScreenSmall && isCardPayment}" @click="search">
                <span class="el-icon-loading" v-if="loading"></span>
                <span v-else>{{$t('tradeMng.panel.btn.query')}}</span>
              </div>
              <div class="panel-header-btn transctl-btn" :class="{'reset_margin': isScreenSmall && isCardPayment}" @click="reset">{{$t('tradeMng.panel.btn.reset')}}</div>
            </div>
          </div>
          <!-- 高级搜索条件 -->
          <!-- <div v-if="!isAdvancedSearchClick" :class="[isScreenBig ? 'advance_large_screen' : 'advance_small_screen', isCardPayment ? 'advance_content_placeholder' : 'advance_large_screen']"></div> -->
          <div v-if="isAdvancedSearchClick" class="panel-select-group advanced">
            <!-- last event -->
            <div class="panel-select__wrapper orderno_nowrap">
              <span class="panel-select__desc">{{$t('tradeMng.panel.lastevent')}}</span>
              <el-form-item prop="cardlastevent">
                <el-select v-model="form.cardlastevent" size="small" :placeholder="$t('common.all')">
                  <el-option v-for="event in eventList" :label="event.name" :value="event.value" :key="event.value"></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="panel-body">
        <div class="panel-btn-group__wrapper panel-body-btn-group flex-normal">
          <div class="num_total">
            <!--<div class="num_wrapper">
              <p class="num-title">{{$t('tradeMng.table.totalAmount')}}</p>
              <p class="num-desc">{{ transData.total_amt | formatNumber }} {{ role.currency }}</p>
            </div>
            <div class="num_wrapper">
              <p class="num-title">{{$t('tradeMng.table.totalNum')}}</p>
              <p class="num-desc">{{ transData.total_num || 0 }} </p>
            </div>-->
            <div class="num_wrapper toolShow4">
              <p class="num-title cell toolShow4">{{$t('tradeMng.table.succAmount')}}</p>
              <p class="num-desc">{{ transData.sucamt | formatNumber }} {{ role.currency }}</p>
            </div>
            <div class="num_wrapper toolShow5">
              <p class="num-title cell toolShow5">{{$t('tradeMng.table.succ')}}</p>
              <p class="num-desc">{{ transData.sucnum || 0 }}</p>
            </div>
            <div class="num_wrapper toolShow6">
              <p class="num-title cell toolShow6">{{$t('tradeMng.table.refundMount')}}</p>
              <p class="num-desc">{{ transData.cancel_amt | formatNumber }} {{ role.currency }}</p>
            </div>
            <div class="num_wrapper toolShow7">
              <p class="num-title cell toolShow7">{{$t('tradeMng.table.refundNum')}}</p>
              <p class="num-default">{{ transData.cancel_num || 0 }}</p>
            </div>
          </div>
          <div class="a-wrapper">
            <el-dropdown>
              <div class="banner-btn" >
                <img src="./img/download.png" alt="download">
                <span class="banner-btn__desc">{{ $t('tradeMng.table.down') }}</span>
              </div>
              <el-dropdown-menu slot="dropdown">
                <a :href="detailHref" download><el-dropdown-item command=1>{{$t('tradeMng.table.btn.downDetail')}}</el-dropdown-item></a>
                <a :href="separateHref" download><el-dropdown-item command=2>{{$t('tradeMng.table.btn.downTrade')}}</el-dropdown-item></a>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <el-table
          :data="transData.data"
          style="width: 100%"
          row-class-name="el-table__row_fix"
          :row-class-name="getStyle"
          v-loading="loading">
          <el-table-column
            :label="$t('tradeMng.table.shopName')" width="110">
            <template slot-scope="scope">
              <div>{{ scope.row.username }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('tradeMng.table.operator')" width="100">
            <template slot-scope="scope">{{ scope.row.opuser || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="busicd_info"
            :label="$t('tradeMng.table.tradeType')" width="100">
          </el-table-column>
          <el-table-column prop="sysdtm" min-width="160" :label="$t('tradeMng.table.tradeTime')">
            <template slot-scope="scope">{{ scope.row.sysdtm }}</template>
          </el-table-column>

          <el-table-column
            :label="$t('tradeMng.table.tradeAmount')" min-width="100" >
            <template slot-scope="scope" >
              <div class="table-title">{{ scope.row.txamt | formatCurrency }}</div>
              <div class="table-content" v-if="scope.row.busicd === '802101'">{{ $t('tradeMng.table.originAmount') }} {{ scope.row.order_amt | formatCurrency }}</div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('tradeMng.table.currency')" width="85">
            <template slot-scope="scope" >
              <div>{{ shop.currency_name }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="status_str" :label="$t('tradeMng.table.tradeState')" width="80"></el-table-column>
          <el-table-column v-if="isCardPayment" key="1" prop="cardlastevent" :label="$t('tradeMng.panel.lastevent')" min-width="140"></el-table-column>
          <el-table-column min-width="140" :label="$t('tradeMng.table.sNum')" label-class-name="toolShow1">
            <template slot-scope="scope">
              <div>{{ scope.row.origssn ? scope.row.syssn + '(' + $t('tradeMng.detail.syssn2') + ':' + scope.row.origssn + ')' : scope.row.syssn }}</div>
            </template>
          </el-table-column>

          <el-table-column prop="chnlsn" :label="$t('tradeMng.table.chnlsn')" width="150" label-class-name="toolShow2"></el-table-column>

          <el-table-column prop="out_trade_no" :label="$t('tradeMng.table.merchantOrder')" width="150" label-class-name="toolShow3"></el-table-column>
          <el-table-column prop="customer_id" :label="$t('tradeMng.table.customerId')" width="110"></el-table-column>

          <el-table-column prop="src" :label="$t('tradeMng.table.src')" width="110"></el-table-column>

          <el-table-column prop="note" :label="$t('tradeMng.table.remark')" width="85"></el-table-column>

          <template v-if="isCardPayment">
            <el-table-column prop="cardcd" :label="$t('tradeMng.table.cardNumber')" min-width="100"></el-table-column>
            <el-table-column prop="cardscheme" :label="$t('tradeMng.table.cardScheme')" min-width="100"></el-table-column>
            <el-table-column prop="cardtype" :label="$t('tradeMng.table.cardType')" min-width="100"></el-table-column>
            <el-table-column prop="cardarea" :label="$t('tradeMng.table.cardArea')" min-width="100"></el-table-column>
          </template>

          <el-table-column :width="lang === 'en'? 280 : 220" :label="$t('tradeMng.table.op')" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" :disabled="showRefund(scope.row)" v-if="refund_visible" class="el-button__fix" @click="confirm(scope.row)">{{$t('tradeMng.table.cancel')}}</el-button>
              <el-button type="text" size="small" class="el-button__fix" @click.native="detail(scope.row)">{{$t('tradeMng.table.detail')}}</el-button>
              <a :href="downUrl" @click="downHref(scope.$index, $event)">
                  <span id="tr-download">{{ $t('tradeMng.table.download') }}</span>
              </a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination_wrapper" v-if="transData.num >= 10">
        <el-pagination
          ref="page"
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="pageSize"
          @size-change="handleSizeChange"
          :total="transData.num"
          @current-change="currentChange"
          :current-page="currentPage">
        </el-pagination>
      </div>
      <div class="table_placeholder" v-else></div>
    </div>

    <el-dialog :title="refundData.isNextDayRefund ? $t('tradeMng.dialog.d8') : $t('tradeMng.dialog.d2')" :visible.sync="showConfirm" custom-class="mydialog" top="20%" @close="handleClose('formpwd')">
      <div style="margin-bottom: 20px;">{{$t('tradeMng.dialog.d1')}}</div>
      <el-form :model="formpwd" :rules="pwdrules" ref="formpwd" :label-width="(lang === 'ja' || lang === 'en') ? '110px' : '80px'" autocomplete="off">
        <el-form-item :label="$t('tradeMng.panel.sNum')">
          <span>{{ refundData.syssn }}</span>
        </el-form-item>
        <el-form-item prop="amount" :label="$t('tradeMng.detail.amount2')" class="amount">
          <span>{{ role.currency }}</span>
          <el-input name="amount" class="showAmount" v-model="formpwd.amount" :placeholder="$t('tradeMng.msg.m14') + ' ' + refundAmount" type="number" @keyup.enter.native="onEnter"></el-input>
        </el-form-item>
        <el-form-item prop="pwd" :label="$t('tradeMng.dialog.d5')">
          <el-input v-model="formpwd.pwd" :placeholder="$t('tradeMng.msg.m9')" auto-complete="new-password" type="password" @keyup.enter.native="onEnter"></el-input>
        </el-form-item>
      </el-form>
      <div class="divider"></div>
      <div slot="footer" class="dialog-footer">
        <div @click="checkPwd" class="submit">
          <span class="el-icon-loading" v-if="iconLoading"></span>
          <span v-else>{{$t('common.confirm')}}</span>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="refundStates !==3 ? (refundStates === 1 ? $t('tradeMng.dialog.d3') : $t('tradeMng.dialog.d7')) : $t('tradeMng.dialog.d4')" :visible.sync="showArefund" custom-class="mydialog refund" :class="[refundStates !== 3 ? (refundStates === 1 ? 'success' : 'wait') : 'fail']" top="20%" :show-close="false">
      <div v-if="refundStates !== 3">
        <el-form :label-width="lang === 'en' ? '150px' : '90px'">
          <el-form-item :label="$t('tradeMng.detail.amount2')">
            <div>
              <span style="font-size: 18px;">{{ role.currency }}</span>
              <span style="font-size: 24px;">{{ refundInfo.txamt | formatCurrency }}</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('tradeMng.table.tradeType')">
            <div>{{ $t('tradeMng.dialog.d6') }}</div>
          </el-form-item>
          <el-form-item :label="$t('tradeMng.detail.syssn3')">
            <div>{{ refundInfo.syssn }}</div>
          </el-form-item>
        </el-form>
      </div>
      <div v-else class="refundfail">
        {{ refundInfo.resperr }}
      </div>
      <div class="divider"></div>
      <div slot="footer" class="dialog-footer">
        <div class="submit" @click="showArefund = false">
          <span>{{$t('common.confirm')}}</span>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="$t('tradeMng.dialog.d9')" :visible.sync="showSubmitRequest" custom-class="mydialog submit_request" class="success" top="20%" :show-close="false">
      <el-form :label-width="lang === 'en' ? '150px' : '90px'" class="content">
        <el-form-item :label="$t('tradeMng.dialog.refundAmount')" class="refund_amount">
          <div>
            <span style="font-size: 18px;">{{ role.currency }}</span>
            <span style="font-size: 24px;" v-if="formpwd.amount">{{ refund_amount }}</span>
          </div>
        </el-form-item>
        <el-form-item :label="$t('tradeMng.dialog.approvalType')" class="approval_type">
          <div>{{ refundData.busicd_info }}</div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import axios from 'axios';
  import config from 'config';
  import qs from 'qs';
  import {formatDate, formatData} from '../../common/js/util';
  import Store from '../../common/js/store';

  // cancel 0未撤销 1撤销 status  0:交易中 1:交易成功 2:交易失败 3:交易超时

  export default {
    data() {
      let checkOrderNo = (rule, val, cb) => {
        if(val && !/^\d+$/.test(val)) {
          cb(this.$t('tradeMng.msg.m1'));
        } else if(val && !/\d{14}/.test(val)) {
          cb(this.$t('tradeMng.msg.m2'));
        } else {
          cb();
        }
      };
      let checkAmount = (rule, val, cb) => {
        if(+val === 0) {
          cb(this.$t('tradeMng.msg.m15'));
        }else if(+val > +this.refundAmount) {
          cb(this.$t('tradeMng.msg.m12'));
        } else {
          cb();
        }
      };
      return {
        refund_visible: '',
        refund_amount: '',
        downUrl: 'javascript:;',
        lang: config.lang,
        refundAmount: 0,
        refundStates: 3,
        role: Store.get('role') || {},
        showConfirm: false,
        showArefund: false,
        showSubmitRequest: false,
        refundData: {},
        refundInfo: {},
        formpwd: {
          amount: null,
          pwd: ''
        },
        iconLoading: false,
        shopLoading: false,
        pageSize: 10,
        status: false,
        loading: false,
        choosetimes: [
          {'name': this.$t('time.today'), 'value': '1'},
          {'name': this.$t('time.yesterday'), 'value': '2'},
          {'name': this.$t('time.near7'), 'value': '7'},
          {'name': this.$t('time.near30'), 'value': '30'},
          {'name': this.$t('time.nearMonth'), 'value': '31'},
          {'name': this.$t('time.nearDay'), 'value': '10'},
        ],
        form: {
          selectShopUid: '',
          orderno: null,
          dateRangeValue: '',
          operaValue: '',
          checkAll1: true,
          checkAll2: true,
          choosetime: '1',
          type: [],
          outtradeno: '',
          cardscheme: '',
          cardlastevent: '',
          chnlsn: null
        },
        isAdvancedSearchClick: false, // 点击高级搜索更新状态
        isCardPayment: false, // 是否有 card payment 支付方式
        isScreenSmall: '',
        eventList: [
          {'name': this.$t('common.all'), 'value': ''},
          {'name': 'Authorized', 'value': 'AUTHORISED'},
          {'name': 'Voided', 'value': 'CANCELLED'},
          {'name': 'Captured', 'value': 'CAPTURED'},
          {'name': 'Refunded', 'value': 'SENT_FOR_REFUND'},
          {'name': 'N/A', 'value': 'none'}
        ],
        schemeList: [
          {'name': this.$t('common.all'), 'value': ''},
          {'name': 'VISA', 'value': 'VISA'},
          {'name': 'Master card', 'value': 'Mastercard'},
          {'name': 'N/A', 'value': 'none'}
        ],
        currentPage: 1,
        operaList: {},
        transData: {},
        formrules: {
          orderno: [
            { validator: checkOrderNo, trigger: 'change' }
          ]
        },
        pwdrules: {
            pwd: [
              { required: true, message: this.$t('tradeMng.msg.m9') }
            ],
          amount: [
            { required: true, message: this.$t('tradeMng.msg.m15') },
            { validator: checkAmount, trigger: 'change' }
          ]
        }
      };
    },
    props: {
      shop: {
        type: Object
      }
    },

    computed: {
      mergeHref() {
        let collectParmas = Object.assign({}, {combine_opuser: 1}, this.basicParams);
        return `${config.host}/merchant/trade/total?${qs.stringify(collectParmas)}`;
      },
      separateHref() {
        let collectParmas
        if (this.isCardPayment) {
          collectParmas = Object.assign({}, {combine_opuser: 0}, this.basicParams, {cardlastevent: this.form.cardlastevent, cardscheme: this.form.cardscheme});
        } else {
          collectParmas = Object.assign({}, {combine_opuser: 0}, this.basicParams);
        }
        return `${config.host}/merchant/trade/total?${qs.stringify(collectParmas)}`;
      },

      detailHref() {
        let detailParmas
        if (this.isCardPayment) {
          detailParmas = Object.assign({}, this.basicParams, {cardlastevent: this.form.cardlastevent, cardscheme: this.form.cardscheme}, {isdownload: true});
        } else {
          detailParmas = Object.assign({}, this.basicParams, {isdownload: true});
        }
        return `${config.host}/merchant/trade/download?${qs.stringify(detailParmas)}`;
      },

      shopData() {
        return this.$store.state.shopData || {};
      },

      typeList() {
        if (this.shop.trade_type !== undefined) {
          this.shop.trade_type.forEach(item => {
            if (item.value === 'credit_card') {
              this.isCardPayment = true
            }
          })
        }
        return this.shop.trade_type || []
      },

      allType() {
        let type = this.shop.trade_type || [];

        return [...type];
      },

      basicParams() {
        let str = '';
        if(!this.form.choosetime) {
          str = 'yyyy-MM-dd HH:mm:ss';
        }
        return {
          userid: this.form.selectShopUid,
          opuid: this.form.operaValue,
          starttime: formatDate(this.form.dateRangeValue[0], str),
          endtime: formatDate(this.form.dateRangeValue[1], str),
          orderno: this.form.orderno,
          chnlsn: this.form.chnlsn,
          outtradeno: this.form.outtradeno,
          charset: 'utf-8',
          isdownload: false,
          page: this.currentPage,
          maxnum: this.pageSize,
          paytypes: this.form.type.join(','),
          // filters: this.form.other.join(','),
          lang: this.lang,
          format: 'cors'
        };
      }
    },

    watch: {
      'form.dateRangeValue': function(val) {
        if(!this.status) {
          this.form.choosetime = '';
        }
        this.status = false;
      },
      'formpwd.amount': function(val, old) {
        if(val) {
          if(this.role.point) {
            // let t = new RegExp('^\\d+(\\.\\d{0,' + this.role.point + '})?$');
            if(!/^\d+(\.\d{0,2})?$/.test(val)) {
              setTimeout(() => {
                this.formpwd.amount = old;
              }, 10);
            }
          }else {
            if(!/^\d+$/.test(val)) {
              setTimeout(() => {
                this.formpwd.amount = old;
              }, 10);
            }
          }
        }
      }
    },

    created() {
      let refund = sessionStorage.getItem('refund')
      if (refund === "true") {
        this.refund_visible = true
      } else {
        this.refund_visible = false
      }
      this.changeTime('1');
      // 子商户查询其收银员
      if(this.role.single) {
        this.form.selectShopUid = this.shop.uid;
        this.getOperators(this.shop.uid);
      }

      this.getTransData();
      this.getScreenWidth()
    },

    mounted() {
      setTimeout(() => {
        this.createDialog(1);
        this.createDialog(2);
        this.createDialog(3);
        this.createDialog(4);
        this.createDialog(5);
        this.createDialog(6);
        this.createDialog(7);
      }, 0);
    },

    methods: {
      getScreenWidth () {
        if (this.lang === 'en') {
          this.isScreenSmall = window.screen.width < 1430
          this.isScreenBig = window.screen.width >= 1430
        } else {
          this.isScreenSmall = window.screen.width < 1364
          this.isScreenBig = window.screen.width >= 1364
        }
      },
      advancedSearch () {
        this.isAdvancedSearchClick = !this.isAdvancedSearchClick
      },
      // 关闭弹出层
      handleClose(form) {
        this.$refs[form] && this.$refs[form].resetFields();
      },

      // 撤销按钮是否禁用,单店展示分店当天展示
      showRefund(val) {
        if(this.role.single) {
          let date = formatDate(this.transData.date || new Date());
          formatDate(val.sysdtm) === date ? this.$set(val, 'isNextDayRefund', false) : this.$set(val, 'isNextDayRefund', true)
          if(val.allow_refund_amt > 0) {
            return false;
          }else {
            return true;
          }
        }else {
          return true;
        }
      },
      // 隔日退款提交申请
      refundApply () {
        const val = this.refundData;
        const params = {
          txamt: val.txamt,
          syssn: val.syssn,
          busicd: val.busicd,
          refund_amt: formatData(this.formpwd.amount, this.role.rate),
          sysdtm: val.sysdtm,
          type: 3,
          format: 'cors'
        }
        axios.post(`${config.oHost}/mchnt/trade/add/refund`, qs.stringify(params), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then(res => {
          let data = res.data
          if (data.respcd === config.code.OK) {
            this.refund_amount = JSON.parse(JSON.stringify(this.formpwd.amount))
            this.showSubmitRequest = true
            this.showConfirm = false
          } else {
            this.$message.error(data.respmsg)
          }
          this.iconLoading = false 
        }).catch(() => {
          this.iconLoading = false 
        })
      },

      // 撤销操作
      revoke() {
        let val = this.refundData;
        let params = {
          format: 'cors',
          syssn: val.syssn,
          refund_amt: formatData(this.formpwd.amount, this.role.rate),
          desc: ''
        };
        if (!this.role.single) {
          params.enuserid = val.en_userid
        }
        axios.post(`${config.host}/merchant/trade/refund`, qs.stringify(params), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        }).then((res) => {
          this.iconLoading = false;
          this.showConfirm = false;
          this.showArefund = true;
          let data = res.data;
          this.refundInfo = data;
          if (data.respcd === config.code.OK) {
            this.refundStates = 1;
            this.getTransData();
          } else if(data.respcd === '1145') {
            // 退款中的处理
            this.refundStates = 2;
            this.getTransData();
          } else {
            this.refundStates = 3;
          }
        }).catch((res) => {
          this.iconLoading = false;
          this.$message.error(this.$t('tradeMng.msg.m7'));
        });
      },

      // 下载小票
      downHref(index, e) {
        let data = this.transData.data[index];
        let totalAmt = (formatData(data.total_amt, 1 / this.role.rate)).toFixed(2);
        e.target.parentNode.href = `${config.host}/merchant/receipt/download?username=${data.username}&busicd_info=${data.busicd_info}&sysdtm=${data.sysdtm}&total_amt=${totalAmt}&status_str=${data.status_str}&syssn=${data.syssn}&format=cors`;
      },

      // 交易，撤销详情
      detail(item) {
        let type = 'trans';
        if(item.origssn) {
          type = 'refund';
        }
        if(item.busicd === '802101') {
          type = 'digital';
        }
        this.$router.push(`/main/transctl/transdetail?syssn=${item.syssn}&type=${type}`);
      },

      // 点击enter键提交
      onEnter() {
        this.checkPwd();
      },

      // 确认弹框验证密码
      checkPwd() {
        this.$refs['formpwd'].validate((valid) => {
          if (valid && !this.iconLoading) {
            this.iconLoading = true;
            axios.post(`${config.host}/merchant/validate_password`, {
              password: this.formpwd.pwd,
              format: 'cors'
            }).then((res) => {
              let data = res.data;
              if (data.data.result === 'success') {
                if (this.refundData.isNextDayRefund) {
                  // 提交退款申请接口
                  this.refundApply()
                } else {
                  this.revoke();
                }
              } else {
                this.iconLoading = false;
                this.$message.error(this.$t('tradeMng.msg.m10'));
              }
            }).catch(() => {
              this.iconLoading = false;
              this.$message.error(this.$t('common.netError'));
            })
          }

        })
      },

      // 撤销按钮
      confirm(val) {
        // 如果有小数点，就显示小数点
        if(this.role.point) {
          this.formpwd.amount = formatData(val.allow_refund_amt, 1 / this.role.rate);
          let v = this.formpwd.amount + '';
          if(v.includes('.')) {
            let p = v.split('.')[1].padEnd(2, 0);
            this.refundAmount = v.split('.')[0] + '.' + p;
          }else {
            let arr = '0';
            arr = arr.padEnd(2, 0);
            this.refundAmount = v + '.' + arr;
          }

        }else {
          this.refundAmount = this.formpwd.amount = formatData(val.allow_refund_amt, 1 / this.role.rate);
        }
        this.refundData = val;
        if(this.role.isCashier) {
          this.cheekRefund();
        }else {
          this.showConfirm = true;
        }
      },

      // 验证收银员退款权限
      cheekRefund() {
        axios.get(`${config.oHost}/mchnt/opuser/perms`, {
          params: {
            format: 'cors'
          }
        }).then((res) => {
          let data = res.data;
          if(data.respcd === config.code.OK) {
            let response = data.data || {};
            if(response.refund === 1) {
              this.showConfirm = true;
            }else {
              this.$message.error(this.$t('tradeMng.msg.m11'));
            }
          } else {
            this.$message.error(data.resperr);
          }
        }).catch(() => {
          this.$message.error(this.$t('common.netError'));
        });
      },

      // 选择时间
      changeTime(value) {
        // 1 2 7 30 31 10
        if(value) {
          this.status = true;
          let [s1, s2, start, end] = [value, 0];

          if(value === '31') {
            let d = new Date();
            let [year, month, day] = [d.getFullYear(), d.getMonth(), d.getDate()];
            let days = (new Date(year, month, 0)).getDate();

            s1 = days;
            s2 = day;
          }else if(value === '10') {
            s1 = (new Date()).getDate();
          }else if(value === '2') {
            s1 = s2 = 1;
          }

          end = new Date((new Date()).getTime() - 3600 * 1000 * 24 * s2);
          start = new Date(end.getTime() - 3600 * 1000 * 24 * (s1 - 1));

          start.setHours(0);
          start.setMinutes(0);
          start.setSeconds(0);

          if(value !== '1' && value !== '10') {
            end.setHours(23);
            end.setMinutes(59);
            end.setSeconds(59);
          }
          this.form.dateRangeValue = [start, end];
        }
      },

      // 支付方式全选check选择功能
      handleCheckAllChange1(event) {
        this.form.type = event.target.checked ? [] : this.allType;
      },

      // 支付方式单选或多选
      handleCheckedCitiesChange1(value) {
        let checkCount = value.length;
        this.form.checkAll1 = !(checkCount > 0);
      },

      // 点击查询
      search() {
        this.handleSizeChange();
      },

      // 获取数据
      getTransData() {
        if(!this.loading) {
          this.loading = true;
          let params = this.basicParams
          if (this.isCardPayment) {
            params.cardlastevent = this.form.cardlastevent
            params.cardscheme = this.form.cardscheme
          }
          axios.get(`${config.host}/merchant/trade/info`, {
            params
          }).then((res) => {
            this.loading = false;
            let data = res.data;
            if(data.respcd === config.code.OK) {
              this.transData = data.data;
            } else {
              this.$message.error(data.resperr);
            }
          }).catch(() => {
            this.loading = false;
            this.$message.error(this.$t('tradeMng.msg.m4'));
          });
        }
      },

      // 查询收银员列表
      getOperators(uid) {
        this.form.operaValue = '';
        axios.get(`${config.host}/merchant/sub/opusers`, {
            params: {
              userid: uid,
              format: 'cors'
            }
          }).then((res) => {
            let data = res.data;
            if(data.respcd === config.code.OK) {
              this.operaList = data.data;
            } else {
              this.$message.error(data.resperr);
            }
          }).catch(() => {
            this.$message.error(this.$t('tradeMng.msg.m5'));
          });
      },

      currentChange(current) {
        if (!current && this.currentPage !== 1) {
          this.currentPage = 1;
          return;
        }
        if (current) {
          this.currentPage = current;
        }

        this.getTransData();
      },

      // 重置表单
      reset() {
        this.status = true;
        this.$refs['form'].resetFields();
      },

      handleSizeChange(size = 10) {
        this.pageSize = size;
        this.currentChange();
      },

      // 行样式
      getStyle(row, index) {
        if(row.allow_refund_amt === 0 && !row.is_refund) {
          return 'trans-refund';
        }
        return '';
      },

      createDialog(val) {
        let toolShow = document.querySelector(".toolShow" + val);
        // 创建弹框节点
        let el = document.createElement("div");
        el.innerHTML = this.$t('tradeMng.table.tip.m' + val);
        el.setAttribute('id', 'toolShow' + val);
        toolShow.appendChild(el);

        toolShow.addEventListener('mouseenter', function (e) {
          let [x, y] = [toolShow.getBoundingClientRect().left, toolShow.getBoundingClientRect().top];
          el.style.left = x + 'px';
          el.style.top = y + 40 + 'px';
          el.style.position = 'fixed';
          el.style.display = 'block';
        }, false);
        toolShow.addEventListener('mouseleave', function () {
          el.style.display = 'none';
          el.style.position = 'static';
        }, false);
      }
    }
  };
</script>

<style lang="scss">
  .el-date-table td {
    vertical-align: middle;
  }

  .panel-select-group {
    display: flex;
    height: 100%;
    width: 100%;
    align-items: center;
  }

  .panel-header__auto {
    height: auto !important;
    padding: 25px 0 20px 15px;
  }

  .panel-btn-group__wrapper {
    display: flex;
    margin-top: 25px;
  }

  .panel-body__fix {
    padding: 5px 15px !important;
  }

  .panel-body-btn-group {
    margin: 10px 0px 20px;
  }
  .trans-refund {
    color: #afafaf;
  }

  .el-table__row_fix {
    height: 62px;
    min-height: 62px;
    color: #282A2D;
  }
  #tr-download {
    color: #FF8100;
  }
  /*.panel-header__auto {*/
    /*position: relative;*/
    /*height: auto !important;*/
    /*padding: 25px 0;*/
  /*}*/

  .panel-select-group__fix {
    margin-bottom: 15px;

  }
  .el-form-item__content {
    .el-checkbox-group{
      display: inline-block;
      .el-checkbox{
        margin-left: 15px;
      }
    }
  }
  .panel-select-input__fix {
    width: auto;
  }

  .down{
    .panel-header {
      background-color: #fff;
    }
    .panel-select-group {
      margin-bottom: 10px;
      position: relative;

      .orderno_nowrap .el-form-item__error {
        overflow: visible;
        white-space: nowrap;
      }
      .panel-select__desc {
        width: 120px;
        margin: 0;
      }
      .el-input__inner {
        width: 220px;
      }
      .el-checkbox__label {
        color: #090909;
      }
    }
    .panel-header__auto {
      padding-bottom: 10px;
    }
    .table-title {
      font-size: 16px;
      font-weight: 500;
    }
    .table-content {
      font-size: 14px;
      text-decoration: line-through;
    }
    .num_total {
      text-align: center;
      display: flex;
      p {
        height: 30px;
        line-height: 30px;
      }
      .num-title {
        font-size: 15px;
      }
      .num-desc {
        font-size: 18px;
        color: #FF8100;
        font-weight: bold;
      }
      .num-default {
        font-size: 18px;
        color: #8A8C92;
        font-weight: bold;
      }
      .num_wrapper {
        margin-left: 30px;
      }
      .toolShow4, .toolShow5, .toolShow6, .toolShow7 {
        cursor: pointer;
        position: relative;
        overflow: visible;
        & .cell:after {
          content: "?";
          font-size: 13px;
          color: #fff;
          border: 1px solid transparent;
          border-radius: 50%;
          background: #c2c2c2;
          padding: 0 4px;
          margin-left: 5px;
        }
      }
      #toolShow4, #toolShow5, #toolShow6, #toolShow7 {
        display: none;
        z-index: 1000;
        width: auto;
        max-width: 200px;
        background: #fff;
        font-size: 13px;
        color: #262424;
        padding: 5px 6px;
        line-height: 22px;
        white-space: normal;
        border-radius: 5px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
      }
    }
    .a-wrapper {
      margin-right: 30px;
      .el-dropdown {
        img {
          width: 20px;
          cursor: pointer;
        }
        .banner-btn__desc {
          font-size: 16px;
        }
      }
    }
  }
  .el-form-item {
    margin-bottom: 0px;
  }
  .panel-select-input-220 {
    width: 220px;
  }
  .mr-16 {
    margin-right: 30px !important;
  }
  .flex-normal {
    justify-content: space-between;
  }

  .transctl {
    .amount {
      span {
        position: absolute;
        left: 5px;
        color: #282B2D;
        z-index: 100;
        width: 30px;
        text-align: center;
      }
      .el-input__inner {
        padding-left: 35px;
        line-height: 36px;
      }
    }
    .success, .wait {
      .el-form-item__content {
        text-align: right;
        color: #2F323A;
      }
    }

    .success .el-dialog__header{
      background: url("img/success.png") top center no-repeat;
    }
    .wait .el-dialog__header{
      background: url("img/wait.png") top center no-repeat;
    }
    .fail .el-dialog__header{
      background: url("img/fail.png") top center no-repeat;
    }
    .refund .el-dialog__header {
        margin-top: 20px;
        padding-top: 48px;
        background-size: 45px 45px;
    }
    .submit_request {
      background-color: #f7f7f7;
      .el-dialog__header {
        margin-top: 20px;
        padding-top: 48px;
        background-size: 45px 45px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
      }
      .el-dialog__body {
        margin-top: 29px;
        padding: 15px 15px 20px;
        .content {
          background-color: #fff;
          padding: 0 15px;
          .el-form-item {
            margin-bottom: 0;
            padding: 5px 0 20px;
            .el-form-item__label {
              color: #a7a7a9;
            }
          }
          .refund_amount {
            border-bottom: 1px solid #f7f7f7;
            padding-top: 72px;
          }
        }
      }
    }
    .refundfail {
      text-align: center;
      color: #262424;
      font-size: 16px;
      padding: 10px 0;
    }

    th.toolShow1, th.toolShow2, th.toolShow3 {
      cursor: pointer;
      position: relative;
      overflow: visible;
      & .cell:after {
        content: "?";
        font-size: 13px;
        color: #fff;
        border: 1px solid transparent;
        border-radius: 50%;
        background: #c2c2c2;
        padding: 0 4px;
        margin-left: 5px;
      }
    }
    #toolShow1, #toolShow2, #toolShow3 {
      display: none;
      z-index: 1000;
      width: auto;
      max-width: 200px;
      background: #fff;
      font-size: 13px;
      color: #262424;
      padding: 5px 6px;
      line-height: 22px;
      white-space: normal;
      border-radius: 5px;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
    }
    .advanced_group_large_style {
      bottom: -48px;
      z-index: 10;
    }
    .advance {
      background-color: #fff;
      border: none;
      color: #FF8100;
      text-align: left;
      width: auto;
      padding: 0;
      padding-right: 15px;
      display: flex;
      align-items: center;
    }
    .margin19 {
      margin-top: 10px;
    }
    .advance:hover {
      background-color: #fff;
    }
    .advanced {
      // margin-top: 20px;
    }
    .advance_content_placeholder {
      height:56px;
    }
    .advanced_group {
      width: 220px;
      height: 36px;
      z-index: 2;
      bottom: 46px;
    }
    .advanced_group_resize {
      bottom: 0;
    }
    .reset_margin {
      margin-top: 10px;
    }
    .advanced_arrow {
      transform: rotateZ(180deg);
    }
    .el-icon-arrow-down {
      color: #FF8100;
      font-size: 12px;
      margin-left: 2px;
    }
    .advance_small_screen {
      height: 56px;
    }
    .advance_large_screen {
      height: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// transctl.vue?2f953991